package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "bn", default = false)
val BnStrings = Strings(
    analyzer = "বিশ্লেষক",
    appreciationOverview = "মূল্যায়ন ওভারভিউ",
    chartLegendInterest = "সুদ",
    chartLegendPrincipal = "মূলধন",
    chartXaxisMonths = "মাস",
    chartYaxisPayment = "পেমেন্ট",
    code = "bn",
    costOfCredit = "ক্রেডিটের খরচ",
    creditDealAnalyzerDescription = "আপনার ঋণের বিবরণ লিখুন আপনার ক্রেডিট ডিলের একটি বিস্তারিত বিশ্লেষণ পেতে। আমাদের বিশ্লেষক আপনার ঋণের আসল খরচ বুঝতে এবং একটি সুচিন্তিত সিদ্ধান্ত নিতে আপনাকে সাহায্য করার জন্য মূল মেট্রিক্স মূল্যায়ন করে।",
    detailsGoodRateLongTerm = "ভাল হার কিন্তু দীর্ঘ মেয়াদ উচ্চ মোট খরচের কারণ হয়।",
    detailsHighApr = "উচ্চ এপিআর। ",
    detailsHighInterestCost = "উচ্চ মোট সুদের খরচ।",
    detailsHighRateShortTerm = "উচ্চ হার কিন্তু স্বল্প মেয়াদ মোট খরচ কম রাখে।",
    detailsLowApr = "কম এপিআর। ",
    detailsLowInterestCost = "কম মোট সুদের খরচ।",
    discountsTradeIn = "ছাড় / ট্রেড-ইন",
    displayName = "বাংলা",
    distribution = "বন্টন",
    downPayment = "ডাউন পেমেন্ট",
    effectiveApr = "এপিআর",
    headerBalance = "ব্যালেন্স",
    headerDate = "তারিখ",
    headerInterest = "সুদ",
    headerMonth = "#",
    headerPayment = "পেমেন্ট",
    headerPrincipal = "মূলধন",
    hideDetails = "বিস্তারিত লুকান",
    interest = "সুদ",
    invalidData = "অবৈধ ডেটা",
    loanAmountSupportingText = "মোট ঋণের পরিমাণ, যেকোনো অতিরিক্ত খরচ সহ।",
    loanDetails = "ঋণের বিবরণ",
    paymentSupportingText = "আপনার আনুমানিক মাসিক পেমেন্ট।",
    paymentComposition = "পেমেন্ট কম্পোজিশন",
    percentSymbol = "%",
    principal = "মূলধন",
    ratingBad = "খারাপ ডিল",
    ratingExcellent = "চমৎকার ডিল",
    ratingFair = "ন্যায্য ডিল",
    ratingGood = "ভাল ডিল",
    ratingPoor = "খারাপ ডিল",
    schedule = "সময়সূচী",
    showDetails = "বিস্তারিত দেখান",
    summaryBad = "খুব প্রতিকূল, সম্ভব হলে এড়িয়ে চলুন।",
    summaryExcellent = "চমৎকার আর্থিক অবস্থা।",
    summaryFair = "ন্যায্য অবস্থা, আলোচনা বিবেচনা করুন।",
    summaryGood = "ভাল অবস্থা, বাজারের জন্য মানসম্মত।",
    summaryPoor = "খারাপ অবস্থা, উচ্চ খরচ বা হার।",
    totalPaid = "মোট পরিশোধিত",
    lockTaxRate = "ট্যাক্স রেট লক করুন",
    unlockTaxRate = "ট্যাক্স রেট আনলক করুন",
    currencySymbol = "৳",
    currency = "মুদ্রা",

    totalCreditAmount = "মোট ক্রেডিট পরিমাণ",
    taxAmount = "ট্যাক্স/ডিডাকশন পরিমাণ",
    netAmountDisbursed = "বিতরণকৃত নেট পরিমাণ", // Изчисляемо поле: totalCreditAmount - всички първоначални такси/данъци

    years = "বছর",
    loanTermTotalMonths = "ঋণের মেয়اد (মাস)", // Изчисляемо অথবা ইনপুট ফিল্ড

    monthlyInstallment = "মাসিক কিস্তি",
    principalInstallment = "মূল কিস্তি",
    otherFees = "অন্যান্য ফি",

    insuranceCost = "বীমা খরচ",
    aprc = "বার্ষিক শতাংশ চার্জের হার (APRC)",
    totalAmountPayable = "মোট প্রদেয় পরিমাণ",
    prepaidFeeFixed = "প্রিপেইড ফি (স্থির পরিমাণ)",
    prepaidFeePercentage = "প্রিপেইড ফি (শতাংশ)",
    months = "মাস",
    description = "এই বিশ্লেষক আপনাকে একটি ঋণ প্রস্তাব আপনার জন্য অনুকূল কিনা তা মূল্যায়ন করতে সাহায্য করে। স্ট্যান্ডার্ড ক্যালকুলেটরগুলির বিপরীতে, এটির জন্য সুদের হার ইনপুট করার প্রয়োজন হয় না। পরিবর্তে, এটি পেমেন্টและ ফি এর উপর ভিত্তি করে এপিআর এবং ক্রেডিটের মোট খরচ গণনা করে, একটি ডিল রেটিং এবং বিস্তারিত চার্ট সরবরাহ করে।",
    agree = "সম্মত",
    information = "তথ্য",
    errorDivisionByZero = "শূন্য দ্বারা বিভাজন",
    errorNegativeResult = "নেতিবাচক ফলাফল",
    errorRateTooHigh = "হার খুব বেশি",
    errorCalculation = "সঠিক ডেটা লিখুন",
    errorCalculationOverflow = "এপিআর খুব বেশি, গণনায় ওভারফ্লো।",
    errorTotalPaymentIsLessThanLoanAmount = "প্রাপ্ত অর্থের পরিমাণ ঋণের পরিমাণের চেয়ে কম।",

    close = "বন্ধ করুন",
    hi = "হাই",
    guest = "অতিথি",
    account = "অ্যাকাউন্ট",
    signInWithGoogle = "Google দিয়ে সাইন ইন করুন",
    signOut = "সাইন আউট",
    settings = "সেটিংস",
    about = "সম্পর্কে",
    privacyPolicy = "গোপনীয়তা নীতি",
    termsOfService = "পরিষেবার শর্তাবলী",

    language = "ভাষা",
    theme = "থিম",
    light = "লাইট",
    dark = "ডার্ক",
    system = "সিস্টেম",
    toggleExpand = "প্রসারিত/সংকুচিত",
)
